import { DocumentIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../shared/utility";
import ImportMediaDropzone from "./ImportMediaDropzone";
import Input from "../controls/Input";

export default function DocumentUi(props) {
  const {
    title,
    uploadedImage,
    isEdit,
    imageUrl,
    imageName,
    handleInputChange,
    onDelete,
    setUploadedImage,
    showNameInput,
    nameInput,
    nameInputValue,
  } = props;

  return (
    <div className="space-y-2">
      <div className="flex space-x-2">
        <label
          htmlFor="imageName"
          className="block text-sm font-medium text-gray-900"
        >
          {title}
        </label>
      </div>
      {showNameInput ? (
        <div>
          <Input
            label=""
            name={nameInput}
            onChange={handleInputChange}
            value={nameInputValue}
            labelOn={false}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
      ) : null}
      <div className="flex gap-2">
        {uploadedImage ? (
          <div>
            <DocumentIcon
              className="h-12 w-12 text-gray-400"
              aria-hidden="true"
            />
          </div>
        ) : isEdit ? (
          imageUrl ? (
            <a
              href={imageUrl}
              target="_blank"
              rel="noreferrer"
              className="rounded-md bg-cyan-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-cyan-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-700"
            >
              View
            </a>
          ) : null
        ) : null}

        <ImportMediaDropzone
          fileName={imageName}
          handleInputChange={handleInputChange}
          setUploadedImage={setUploadedImage}
        />
        <div>
          <button
            type="button"
            className={classNames(
              imageUrl
                ? "rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-700"
                : "hidden",
            )}
            onClick={onDelete}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
